<template>
  <a-dropdown :trigger="['click']" placement="bottomLeft" @visibleChange="addCount">
    <div :class="$style.dropdown">
      <div class="row rounded">
        <div class="">
          <a-avatar shape="square" icon="setting" size="large" :class="$style.avatar" />
        </div>
        <div class="d-md-block d-none pr-2">
          <div :class="$style.neo_username_role">
            <div :class="$style.neo_username" class="text-dark">{{ user.first_name }} {{ user.last_name }}</div>
            <div :class="$style.neo_user_role">{{ user.role}}</div>
          </div>
        </div>
      </div>
    </div>
    <a-menu slot="overlay">
      <a-menu-item>
        <strong>Hello, {{ user ? user.first_name : ''}} {{ user ? user.last_name : ''}}</strong>
        <!-- <div>
          <strong class="mr-1">Billing Plan:</strong>
          Professional
        </div> -->
        <div>
          <strong>Role:</strong>
          {{ user && user.role !== 'normal' ? (user.role.charAt(0).toUpperCase() + user.role.slice(1)) : 'Student'}}
        </div>
      </a-menu-item>
      <a-menu-divider />
      <a-menu-item>
        <div v-if="['normal'].includes(user.role)">
          <strong class="mr-1">Std. Code:</strong> {{ user && user.student ? user.student.student_code : '--'}}
        </div>
        <div v-if="!['normal'].includes(user.role)">
          <strong class="mr-1">Email:</strong> {{ user && user.email ? user.email : '--'}}
        </div>
        <div v-if="!['normal'].includes(user.role)">
          <strong class="mr-1">Phone:</strong> {{ user && user.phone ? user.country_code + user.phone : '--'}}
        </div>
      </a-menu-item>
      <a-menu-divider />
      <a-menu-item v-if="user.role === 'admin'">
        <a href="javascript: void(0);" @click="handleSettingsClick">
          <i :class="$style.menuIcon" class="fe fe-settings"></i> School Settings
        </a>
      </a-menu-item>
      <a-menu-item>
        <a href="javascript: void(0);" @click="handleProfileClick">
          <i :class="$style.menuIcon" class="fe fe-user"></i> Edit Profile
        </a>
      </a-menu-item>
      <a-menu-item v-if="['admin', 'superadmin', 'supervisor', 'teacher'].includes(user.role)">
        <a href="javascript: void(0);" @click="showActivityLog">
          <i :class="$style.menuIcon" class="fe fe-alert-circle"></i> Activity Log
        </a>
      </a-menu-item>
      <a-menu-item>
        <a href="javascript: void(0);" @click="logout">
          <i :class="$style.menuIcon" class="fe fe-log-out"></i> Logout
        </a>
      </a-menu-item>
    </a-menu>
  </a-dropdown>
</template>

<script>
export default {
  props: ['user'],
  data: function () {
    return {
      count: 7,
    }
  },
  methods: {
    addCount() {
      this.count = 7
    },
    handleSettingsClick() {
      if (this.$route.name !== 'institutesettings') {
        this.$router.push({ path: '/settings/institute' })
      }
    },
    handleProfileClick() {
      if (this.$route.name !== 'profilesettings') {
        this.$router.push({ path: '/settings/profile' })
      }
    },
    logout() {
      this.$auth.logout()
    },
    showActivityLog() {
      this.$eventBus.$emit('openActivityLogDrawer')
    },
  },
}
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>
